import C from "@/components/forms/FormField.module.css";
import { cn } from "@/utils/classNames.ts";
import type { ReactNode } from "react";
import { Group } from "react-aria-components";

export function FieldButtonGroup({
    children,
    hasAbsoluteButton,
}: {
    children: ReactNode;
    hasAbsoluteButton?: boolean;
}) {
    return <Group className={cn(C.Group, hasAbsoluteButton && C.AbsoluteButton)}>{children}</Group>;
}
